import styles from './SunGlow.module.css';

interface SunGlowProps {
  /** Changes on every bell so the glow pulses once. */
  pulseKey?: number;
  /** Stops the slow breathing (during a session). */
  frozen?: boolean;
  /** Fills the screen once, for "Practice complete". */
  bloom?: boolean;
  /** 'page' sits low like a rising sun; 'center' sits behind the content. */
  position?: 'page' | 'center';
}

export const SunGlow = ({ pulseKey = 0, frozen = false, bloom = false, position = 'page' }: SunGlowProps) => (
  <div className={`${styles.wrap} ${position === 'center' ? styles.center : ''}`} aria-hidden="true">
    <div key={bloom ? 'bloom' : pulseKey} className={`${styles.glow} ${frozen ? styles.frozen : ''} ${pulseKey > 0 && !bloom ? styles.pulse : ''} ${bloom ? styles.bloom : ''}`} />
  </div>
);
